<div class="modal-header" mat-dialog-title>
  <div class="modal-header-titles">
    <h2 class="modal-title">Alterar tags</h2>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="dialogRef.close()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p class="texto-pergunta">O que deseja fazer com as {{ data.quantidadeSelecionada }} ordem(ns) selecionada(s)?</p>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Ação</mat-label>
    <mat-select [(ngModel)]="modo">
      <mat-option value="incluir">Incluir tags</mat-option>
      <mat-option value="excluir">Excluir tags</mat-option>
    </mat-select>
    <mat-hint>{{textoAjuda}}</mat-hint>
  </mat-form-field>

  <div class="tags-header">
    <span class="tags-label">Selecione as tags</span>
    @if (tagsSelecionadas.size > 0) {
    <span class="status-badge badge-vermelho">{{ contadorTexto }}</span>
    }
  </div>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Buscar tags...</mat-label>
    <mat-icon matPrefix>search</mat-icon>
    <input matInput type="text" [(ngModel)]="textoBusca" />
  </mat-form-field>

  <div class="lista-tags">
    @for (tag of tagsFiltradas; track tag.idTagProducao) {
    <div class="linha-tag" (click)="alternarTag(tag.idTagProducao)">
      <mat-checkbox [checked]="tagsSelecionadas.has(tag.idTagProducao)" (click)="$event.stopPropagation()"
        (change)="alternarTag(tag.idTagProducao)">
        <span class="tag-label">
          <span class="tag-cor" [style.background-color]="tag.cor"></span>
          {{ tag.descricao }}
        </span>
      </mat-checkbox>
    </div>
    }
    @if (tagsFiltradas.length === 0) {
    <p class="empty-tags">Nenhuma tag encontrada.</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="dialogRef.close()">Cancelar</button>
  <button mat-flat-button class="btn-primary" [disabled]="!podeAplicar" (click)="aplicar()">Aplicar</button>
</mat-dialog-actions>